import { Theme } from '@mui/material'

const classes = {
  routeWrapperContainer: (theme: Theme) => ({
    overflowX: 'hidden',
    [theme.breakpoints.up('sm')]: {
      overflowX: 'visible',
      width: '350px',
      margin: '0 auto',
    },
  }),
  mainGridWrapper: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.primary50,
    color: theme.palette.text.onPrimary,
  }),
  errorAlert: (theme: Theme) => ({
    width: '100%',
    marginTop: theme.spacing(2),
  }),
  containerRoot: {
    minHeight: '100vh',
    flexDirection: 'column',
    flexGrow: 1,
  },
  routeWrapperGrid: {
    justifyContent: 'center',
    flexGrow: 1,
    paddingX: '16px',
  },
  contentGrid: (footerSpacing?: number) => ({
    maxWidth: 'xl',
    flexGrow: 1,
    minWidth: 0,
    mb: { sm: 8 },
    padding: 0,
    ...(footerSpacing ? { paddingBottom: `calc(${footerSpacing}px + 16px)` } : {}),
  }),
  loadingGrid: {
    justifyContent: 'center',
    marginTop: 24,
  },
  desktopContentGrid: (theme: Theme) => ({
    flexGrow: 1,
    padding: 3,
    bgcolor: theme.palette.ui.surface2,
    maxHeight: 'calc(100dvh - 67px)',
    overflowY: 'hidden',
  }),
  sidenavGridItem: (theme: Theme) => ({
    paddingX: 1.5,
    paddingTop: 0,
    paddingBottom: 3,
    borderRadius: '8px',
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: 'calc(100dvh - 67px - 40px)', // 67px = header height, 40px = paddingBottom + surrounding vertical spacing
    bgcolor: theme.palette.ui.surfaceContainerLow,
    '&:empty': {
      display: 'none',
    },
  }),
  childrenGridItem: (theme: Theme) => ({
    paddingX: 2,
    borderRadius: '8px',
    overflowX: 'hidden',
    overflowY: 'auto',
    maxHeight: 'calc(100dvh - 67px - 48px)', // 67px = header height, 48px = paddingTop + paddingBottom
    bgcolor: theme.palette.ui.surfaceContainer,
    '&:empty': {
      display: 'none',
    },
  }),
  outletGridItem: (theme: Theme, outletAlignStart?: boolean) => ({
    paddingX: 2,
    paddingTop: 1,
    paddingBottom: 3,
    borderRadius: '8px',
    overflowX: 'hidden',
    maxHeight: 'calc(100dvh - 67px - 48px)', // 67px = header height, 48px = paddingTop + paddingBottom
    bgcolor: theme.palette.ui.surfaceContainer,
    ...(outletAlignStart && { alignSelf: 'flex-start' }),
    '&:empty': {
      display: 'none',
    },
  }),
  loadingContainer: {
    justifyContent: 'center',
    marginTop: 24,
  },
  onboardingRoot: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surface,
    justifyContent: 'center',
    alignItems: 'center',
  }),
  onboardingContent: (theme: Theme) => ({
    width: '684px',
    maxWidth: '100%',
    height: { xs: '100dvh', sm: 'min(844px, 100dvh)' },
    flexDirection: 'column',
    overflow: 'hidden',
    borderRadius: '12px',
    backgroundColor: theme.palette.background.paper,
  }),
  onboardingLoadingContainer: {
    flexGrow: 1,
    alignItems: 'center',
    marginTop: 0,
  },
  mobileContainer: (theme: Theme, shouldConstrainWidth: boolean) => ({
    justifyContent: 'center',
    flexGrow: 1,
    paddingX: '16px',
    bgcolor: theme.palette.ui.surface2,
    ...(shouldConstrainWidth && {
      overflowX: 'hidden',
    }),
  }),
  mobileContentGrid: (footerSpacing?: number) => ({
    maxWidth: 'xl',
    flexGrow: 1,
    minWidth: 0,
    mb: { sm: 8 },
    padding: 0,
    paddingBottom: footerSpacing ? `calc(${footerSpacing}px + 16px)` : undefined,
  }),
}

export default classes
